module.exports = __webpack_public_path__ + "static/media/annotation.ea5038b6.svg";